import { useEditor } from '@/state/store'
import { SPACE_KINDS, SURFACE_BY_ID } from '@/model/materials'

/** Picks the kind (room / terrace / open area …) applied to spaces you draw next. */
export function DrawPanel() {
  const drawKind = useEditor((s) => s.drawKind)
  const setDrawKind = useEditor((s) => s.setDrawKind)
  const setTool = useEditor((s) => s.setTool)

  return (
    <section className="panel draw-panel">
      <div className="panel-head">
        <h3>Draw as</h3>
      </div>
      <div className="kind-list">
        {SPACE_KINDS.map((k) => {
          const surf = SURFACE_BY_ID[k.defaultSurface]
          const active = drawKind === k.id
          return (
            <button
              key={k.id}
              className={`kind-item${active ? ' active' : ''}`}
              onClick={() => {
                setDrawKind(k.id)
                setTool('space-rect')
              }}
              title={k.description}
            >
              <span className="kind-swatch" style={{ background: surf.color }} />
              <span className="kind-text">
                <span className="kind-label">{k.label}</span>
                <span className="kind-desc">{k.description}</span>
              </span>
            </button>
          )
        })}
      </div>
      <p className="hint-note">Pick a kind, then drag (R) or pen (P) to draw. Walls &amp; ceiling follow the kind; tweak any space in the inspector.</p>
    </section>
  )
}
